<p-overlayPanel #tourOverlayPanel [styleClass]="'tour-overlay-panel'">
  <div class="flex flex-col gap-3 w-25rem">
    <ng-container *ngIf="isLoading; else contentTemplate">
      <p-progressSpinner styleClass="w-[32px] h-[32px]" strokeWidth="4" />
    </ng-container>
    <ng-template #contentTemplate>
      <ng-container *ngIf="tourDetails; else noDataTemplate">
        <div class="flex flex-col">
          <div class="text-base font-medium leading-3r w-full">Status</div> 
          <div class="text-base text-[#848488] leading-3">
            <p-tag class="mr-2" [value]="tourDetails?.getStateLabel()" [severity]="tourDetails?.getStateSeverity()"></p-tag>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="text-base font-medium leading-3r w-full">Fahrzeug</div>
          <div class="text-base text-[#848488] leading-3">{{ (tourDetails?.resource?.text) || '-' }}</div>
        </div>
        <div class="flex flex-col">
          <div class="text-base font-medium leading-3r w-full">Fahrer</div>
          <div class="text-base text-[#848488] leading-3">{{ tourDetails?.driver ? (tourDetails?.driver?.firstName + ' ' + tourDetails?.driver?.lastName) : '-' }}</div>
        </div>
      </ng-container>
      <ng-template #noDataTemplate>
        <div class="text-sm text-color-secondary">Keine Tour-Details verfügbar</div>
      </ng-template>
    </ng-template>
  </div>
</p-overlayPanel>
